import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, MenuItem } from '@mui/material';

export default function AdminCardIssueDialog({ open, onClose, onIssue }) {
  const [form, setForm] = useState({ user_id: '', type: 'visa' });
  const [users, setUsers] = useState([]);

  useEffect(() => {
    if (!open) return;
    const token = localStorage.getItem('token');
    axios.get('https://api.safenetbanking.com/api/user/all', {
      headers: { Authorization: 'Bearer ' + token }
    }).then(res => setUsers(res.data)).catch(() => setUsers([]));
  }, [open]);

  const handleChange = e => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };
  const handleSubmit = () => {
    if (!form.user_id || !form.type) return;
    onIssue({ user_id: form.user_id, type: form.type });
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Issue New Card</DialogTitle>
      <DialogContent>
        <TextField
          margin="dense"
          label="User"
          name="user_id"
          value={form.user_id}
          onChange={handleChange}
          select
          fullWidth
        >
          {users.map(u => (
            <MenuItem key={u.id} value={u.id}>{u.full_name || u.email || u.id}</MenuItem>
          ))}
        </TextField>
        <TextField margin="dense" label="Type" name="type" value={form.type} onChange={handleChange} select fullWidth>
          <MenuItem value="visa">Visa</MenuItem>
          <MenuItem value="mastercard">MasterCard</MenuItem>
        </TextField>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" onClick={handleSubmit}>Issue</Button>
      </DialogActions>
    </Dialog>
  );
}
